import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { AppText } from "@toothfairy/shared-ui";
import AppExpander from "@toothfairy/shared-ui/AppExpander";
import React from "react";
import { useTranslation } from "react-i18next";
import { Platform, View } from "react-native";
import Constants from "../../../Constants";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import { isLargeScreen } from "../../MainViewContainer";
import useSections from "../../../Hooks/useSections";

const chunkingStrategyOptions = ["keywords", "summary"];
const imageExtractionStrategyOptions = ["safe", "brute"];

const EmbeddingsSettingsView = ({
  onSubmit = () => {},
  initialValues,
  saveInProgress,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const { getActiveWorkspace } = useWorkspaces();
  const { marginLeftUnderAppExpander } = useSections();
  const AppToasty = AppToast.useToast();

  const chartingSchema = AppForms.yup.object().shape({
    maxChunkWords: AppForms.yup.number().min(200).max(1500),
    maxOverlapSentences: AppForms.yup.number().min(0).max(5),
    chunkingStrategy: AppForms.yup.mixed().oneOf(chunkingStrategyOptions),
    imageExtractionStrategy: AppForms.yup
      .mixed()
      .oneOf(imageExtractionStrategyOptions),
    minImageWidth: AppForms.yup.number().min(100),
    minImageHeight: AppForms.yup.number().min(100),
    aspectRatioMin: AppForms.yup.number().min(0.1),
    aspectRatioMax: AppForms.yup.number().min(1),
  });

  return (
    <View
      style={{
        width: Platform.OS === "web" && isLargeScreen() ? 450 : 350,
        marginTop: 20,
        marginLeft: marginLeftUnderAppExpander,
        alignSelf: "center",
      }}
    >
      <AppForms.AppForm
        style={{
          minWidth: Platform.OS === "web" && isLargeScreen() ? 350 : 250,
          maxWidth: 350,
          alignSelf: "center",
        }}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={chartingSchema}
      >
        <AppExpander
          title={t("admin.embeddings.textChunkingTitle")}
          icon={AppAssets.icons.deepFileSearch}
          style={{ minWidth: isLargeScreen() ? 530 : 250 }}
          isExpandedOnLoad={true}
        >
          <View
            style={{
              paddingLeft: 10,
            }}
          >
            <AppForms.AppFormDropDown
              isElevated={false}
              dropDownStyle={{
                borderColor: currentTheme?.theme?.border_color,
              }}
              inputLabelStyle={{
                marginLeft: -5,
              }}
              showTextInputLabel
              label={t("admin.embeddings.chunkingStrategy")}
              name="chunkingStrategy"
              items={[
                {
                  name: t("admin.embeddings.strategies.keywords"),
                  id: "keywords",
                },
                {
                  name: t("admin.embeddings.strategies.summary"),
                  id: "summary",
                },
              ]}
              propertyLabel="name"
              propertyValue="id"
            />
            <AppForms.AppFormTrackSlider
              step={1}
              maximumValue={1500}
              minimumValue={200}
              label={t("admin.embeddings.chunkMaxWords")}
              name="maxChunkWords"
            />
            <AppForms.AppFormTrackSlider
              step={1}
              maximumValue={5}
              minimumValue={1}
              label={t("admin.embeddings.chunkSentencesOverlap")}
              name="maxOverlapSentences"
            />
          </View>
        </AppExpander>

        <AppExpander
          title={t("admin.embeddings.imageExtractionTitle")}
          icon={AppAssets.icons.image}
          style={{ minWidth: isLargeScreen() ? 530 : 250 }}
          isExpandedOnLoad={true}
        >
          <View
            style={{
              paddingLeft: 10,
            }}
          >
            <AppForms.AppFormTrackSlider
              step={1}
              maximumValue={1500}
              minimumValue={100}
              label={t("admin.embeddings.minImageWidth")}
              name="minImageWidth"
            />
            <AppForms.AppFormTrackSlider
              step={1}
              maximumValue={1500}
              minimumValue={100}
              label={t("admin.embeddings.minImageHeight")}
              name="minImageHeight"
            />
            <AppForms.AppFormTrackSlider
              step={0.1}
              maximumValue={6}
              minimumValue={0.1}
              label={t("admin.embeddings.minAspectRatio")}
              name="aspectRatioMin"
            />
            <AppForms.AppFormTrackSlider
              step={0.1}
              maximumValue={6}
              minimumValue={1}
              label={t("admin.embeddings.maxAspectRatio")}
              name="aspectRatioMax"
            />
          </View>
        </AppExpander>

        <AppForms.AppSubmitButton
          title={t("admin.embeddings.saveButton")}
          isDisabled={saveInProgress}
          awesomeIconColor={currentTheme?.theme?.white}
          backgroundColor={currentTheme?.theme?.primary}
          btnContentStyle={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
          style={[
            {
              height: Constants.appButtonHeight,
              width: "auto",
              shadowColor: currentTheme?.theme?.transparent,
              marginHorizontal: 10,
            },
          ]}
          wrapperStyle={[
            {
              width: "fit-content",
              minWidth: 150,
              marginTop: 20,
              alignSelf: "center",
              height: Constants.appButtonHeight,
            },
          ]}
        />
      </AppForms.AppForm>

      <AppText
        leftIcon={AppAssets?.icons?.question_icon}
        iconSize={18}
        color={currentTheme?.theme?.orange}
        style={{
          marginLeft: 10,
          textDecorationColor: currentTheme?.theme?.orange,
        }}
        wrapperStyle={{
          padding: 15,
          paddingHorizontal: 50,
        }}
      >
        {t("admin.embeddings.relunchWarning")}
      </AppText>
    </View>
  );
};

export default EmbeddingsSettingsView;
